import React from 'react';
import { memo } from 'react';
import { StyledFlexBox } from './FlexBox.styles';

const FlexBox = ({ gap = 0, display = 'flex', ...props }) => (
  <StyledFlexBox display={display} gap={Number(gap)} {...props} />
);

export default memo(FlexBox);
